import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
import AuthRoutes from './app/auth.routes';
import AppRoutes from './app/app.routes';
import MeuPerfilRoutes from './meuPerfil/index.routes';
import ProdutosAssinaturasRoutes from './produtosAssinaturas/index.routes';
import MeusPontosRoutes from './meusPontos/index.routes';

Vue.use(Router);

const HORIZONTAL_POSITION = 0;
const VERTICAL_POSITION = 0;

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (from.name === 'login') {
      return {
        x: HORIZONTAL_POSITION,
        y: VERTICAL_POSITION,
      };
    }
    return savedPosition;
  },
  routes: [
    {
      path: '/',
      name: 'index',
      beforeEnter: (to, from, next) => {
        const name = 'minhas-compras';
        return next({ name });
      },
    },
    ...AppRoutes,
    ...AuthRoutes,
    ...MeuPerfilRoutes,
    ...ProdutosAssinaturasRoutes,
    ...MeusPontosRoutes,
  ],
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  store.dispatch('setMenuAberto', false);

  if (to.name === 'logar') {
    store.dispatch('setToken', to.params.token);
    return next('/');
  }

  if (to.name === 'solicitacao-de-reembolso' && store.state.dadosCompra.reembolso !== true) {
    return next('/');
  }

  const authRequired = !to.matched.some(route => route.meta.public);
  const loggedIn = store.getters.token;
  if (authRequired && !loggedIn) {
    store.dispatch('setUrlAntesLogin', to.path);

    if (to.query.login) {
      return next(`/login?login=${to.query.login}`);
    }

    return next('/login');
  }

  return next();
});

export default router;
